import { ReactComponent as AlarmSvgIcon } from "../../../assets/svg/alarm-clock-clock-svgrepo-com.svg"
import React, { useEffect, useState } from 'react'
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { useDarkMode } from "../../../rdxsga/hooks/common/useDarkMode";
import { getAnimationConfig } from "../../../config/functions";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup'
import { useForm } from 'react-hook-form';
import moment from 'moment';
import ControllerWithDate from '../fields/ControllerFields/ControllerWithDate';
import ControllerWithText from "../fields/ControllerFields/ControllerWithText";
import { useNotificationSocket } from "../../../context/NotificationSocketProvider";
import { useApplicationApi } from "../../../rdxsga/hooks/actions/application/useApplicationApiHook";
import { toast } from "react-toastify";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import ControllerWithDateTime from "../fields/ControllerFields/ControllerWithDateTime";
import ControllerWithTextAreaField from "../fields/ControllerFields/ControllerWithTextAreaField";
import { useRemainderApi } from "../../../rdxsga/hooks/actions/remainder/useRemainderApiHook";

const scheduleDate = Yup.object().shape({
    reminderDateTime: Yup.string().required("Time is required"),
    message: Yup.string().required("message is required")
})

const ShowRemainderModel = ({
    open,
    cancelText = "No",
    confirmText = "Yes",
    animateFrom = "bottom",
    remaindersData,
    textBox = false
}) => {
    const darkMode = useDarkMode();
    const [schedule, setSchedule] = useState(false);
    const { socket: notifySocket } = useNotificationSocket();
    const applicationApi = useApplicationApi()
    const [allNotes, setAllNotes] = useState([]);
    const [currentPosition, setCurrentPosition] = useState(0);
    const reminderApi = useRemainderApi();
    const currentReminder = remaindersData[currentPosition];
    const applicationData = JSON.parse(currentReminder?.extraData);

    console.log({ currentReminder, applicationData })



    const { control, handleSubmit, reset, setValue } = useForm({
        resolver: yupResolver(scheduleDate),
        defaultValues: {
            reminderDateTime: currentReminder.reminderDateTime,
            message: currentReminder.message,
        },
        mode: "onChange"
    })


    const approveRemainHandler = (id) => {
        console.log({ message: "Notifications is read" });
        console.log({ id })
        notifySocket.emit("markAsRead", { id });
        if (remaindersData.length - 1 > currentPosition) {
            setCurrentPosition(0);
        } else {
            // setHandleOpen(false);
            // toast.info("Please refresh the page")
        }

    }

    const rescheduleHandler = async (data) => {
        reminderApi.editReminder({ ...data, id: applicationData?.reminderId }, (msg, res) => {
            console.log({ msg, res })
            approveRemainHandler(currentReminder._id);
            toast.success(msg)
            reset();
            setSchedule(false);
        }, (msg, res) => {
            toast.error(msg)
        })

    }

    const rescheduleCancelHandler = () => {
        console.log("we cancel the reschedule the task");
        reset();
        setSchedule(false);
    }

    const closeMessageModal = () => {
        console.log("we try to reschedule it")
        setSchedule((prev) => !prev)
        console.log(schedule);
    }

    useEffect(() => {
        if (currentReminder) {
            setValue('message', currentReminder.message)
            toast.info(applicationData)
            applicationApi.fetchAllNotes({ id: applicationData._id }, (msg, res) => {
                console.log({ res })
                setAllNotes(res);
            }, (msg, res) => {
                toast.error(msg)
            })
        }
    }, [currentReminder])
    return (
        <Dialog
            className={`${darkMode ? "bg-boxdark" : "bg-white"} mt-[50vh]  overflow-auto pt-5 px-10`}
            animate={getAnimationConfig(animateFrom)}
            size="sm"
            open={open}
        >
            <AlarmSvgIcon className="h-[70px] text-center w-full" />
            <div className="absolute top-1 left-1">
                <ChevronLeft

                    className="cursor-pointer"
                    onClick={() => setCurrentPosition((prev) => prev > 0 ? prev - 1 : 0)} />
                <span className="bg-red-500 text-white px-1 py-0.5 rounded text-sm">{currentPosition + 1}/{remaindersData.length} reminders</span>
                <ChevronRight
                    className="cursor-pointer"
                    onClick={() => setCurrentPosition((prev) => prev < remaindersData.length - 1 ? prev + 1 : remaindersData.length - 1)}
                />
            </div>
            {/* <DialogHeader className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-black text-center"} items-center justify-center             `}>{remaindersData[currentPosition].title}</DialogHeader> */}
            <DialogBody className={`${darkMode ? "bg-boxdark" : "bg-white"} flex justify-center flex-col items-center pt-1`}>
                <span className="text-md text-orange-900">{applicationData?.reminderDateTime?.replace("T", " ")}</span>
                <span className="text-2xl font-extrabold text-black">{currentReminder?.title}</span>
                <span className="text-sm text-blue-gray-600">{currentReminder?.message}</span>

                <div className="flex flex-col w-full">
                    {/* <p className="text-blue-gray-400">Company Details</p> */}
                    <table className="w-full min-w-max table-auto text-left">
                        <tbody>

                            <tr>
                                <th className="text-sm ">Account Number</th>
                                <th className="text-sm ">Business Name</th>
                                <th className="text-sm ">Email</th>
                                <th className="text-sm ">PhoneNumber</th>

                            </tr>
                            <tr>
                                <td className="text-xs text-black">{applicationData?.accId}</td>
                                <td className="text-xs text-black">{applicationData?.companyName}</td>
                                <td className="text-xs text-black">{applicationData?.email}</td>
                                <td className="text-xs text-black">{applicationData?.phoneNumber}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>

                            <tr>
                                <th className="text-sm ">LiveDate</th>
                                <th className="text-sm ">Telephone Number</th>
                                <th className="text-sm ">Application Status</th>
                            </tr>




                            <tr>
                                <td className="text-xs text-black">{applicationData?.liveDate}</td>
                                <td className="text-xs text-black">{applicationData?.telephoneNumber}</td>
                                <td className="text-xs text-black">{applicationData?.isFullySubmitted == "true" ? applicationData?.saleStatus : "No Submitted"}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="flex flex-col w-full pt-10">
                    <p className="w-full text-center font-bold text-blue-gray-500">Recent Notes</p>
                    <table className="w-full min-w-max table-auto text-left">

                        <thead>
                            <tr>
                                <th className="text-sm w-1/3">Username</th>
                                <th className="text-sm w-1/3">Note</th>
                                <th className="text-sm w-1/3">Date & Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allNotes && allNotes?.length > 0 ? allNotes.map((item, index) => {
                                if (index < 4) {
                                    return (
                                        <tr key={item._id}>
                                            <td className="text-xs w-1/3">{`${item?.user?.user?.firstName}${item?.user?.user?.firstName ? ` ${item?.user?.user?.middleName}` : " "}${item?.user?.user?.lastName}`}</td>
                                            <td className="text-xs w-1/3">{item.message}</td>
                                            <td className="text-xs w-1/3">{moment(item.createdAt).format("MMMM DD, YYYY - hh:mm:ss a")}</td>
                                        </tr>
                                    )
                                }
                            }) : "No Notes Found"}
                        </tbody>
                    </table>
                </div>

                {schedule &&
                    <form onSubmit={handleSubmit((data) => rescheduleHandler(data))}
                        className="flex justify-start flex-col w-full">
                        <ControllerWithDateTime
                            control={control}
                            name={"reminderDateTime"}
                            label={"Reschedule Date & Time"}
                            // min={moment().tz('Europe/London').format("YYYY-MM-DDTHH:mm")}
                            required
                        />
                        <ControllerWithTextAreaField
                            control={control}
                            name={"message"}
                            label={"Message"}
                            required
                        />
                        <div
                            className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-white"} flex justify-end`}
                        >
                            <Button
                                variant="filled"
                                color="blue"
                                type='submit'
                                className={`mr-3`}>
                                <span>Reschedule</span>

                            </Button>
                            <Button variant="filled"
                                type='button'
                                color="red"
                                onClick={rescheduleCancelHandler}
                            >

                                <span>Cancel</span>
                            </Button>
                        </div>
                    </form>}

            </DialogBody>
            {!schedule && <DialogFooter
                className={`${darkMode ? "bg-boxdark text-white" : "bg-white text-white"}`}
            >
                <Button
                    variant="filled"
                    color="blue"
                    onClick={() => approveRemainHandler(remaindersData[currentPosition]._id)}
                    className={`mr-3`}>
                    <span>Mark as Done</span>

                </Button>
                <Button variant="filled" color="red"
                    onClick={closeMessageModal}
                >

                    <span>{cancelText}</span>
                </Button>
            </DialogFooter>}
        </Dialog>
    )
}

export default ShowRemainderModel;